import { GREASY_SKIN_LOCATION } from '@/modules/questionnaire/api/constants';

export const GREASY_SKIN_LOCATION_OPTIONS = [
  { value: GREASY_SKIN_LOCATION.TZONE_ONLY, text: 'greasySkinLocation.tzoneOnly' },
  { value: GREASY_SKIN_LOCATION.CHEEKS_AND_TZONE, text: 'greasySkinLocation.cheeksAndTzone' }
];
